import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const FormTags = ({ tags, formatTag }) => {
  const containerRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(tags.length);

  useEffect(() => {
    const calculateVisible = () => {
      const container = containerRef.current;
      if (!container) return;

      const containerWidth = container.offsetWidth;
      const children = Array.from(container.children);

      if (!children.length) return;

      let usedWidth = 0;
      let count = 0;

      // Create temporary "+X more" element to measure width
      const moreEl = document.createElement('span');
      moreEl.className = 'badge bg-secondary text-white';
      moreEl.style.fontSize = '12px';
      moreEl.style.padding = '6px 10px';
      moreEl.style.borderRadius = '20px';
      moreEl.style.whiteSpace = 'nowrap';
      moreEl.style.visibility = 'hidden';
      moreEl.innerText = `+${tags.length} more`;

      document.body.appendChild(moreEl);
      const moreWidth = moreEl.offsetWidth + 8;
      document.body.removeChild(moreEl);

      for (let i = 0; i < children.length; i++) {
        const width = children[i].offsetWidth + 8;

        // Reserve space for "+X more"
        if (usedWidth + width + moreWidth > containerWidth) break;

        usedWidth += width;
        count++;
      }

      setVisibleCount(count);
    };

    calculateVisible();
    window.addEventListener('resize', calculateVisible);
    return () => window.removeEventListener('resize', calculateVisible);
  }, [tags]);

  const hiddenCount = tags.length - visibleCount;

  return (
    <div
      ref={containerRef}
      className="d-flex flex-nowrap align-items-center"
      style={{ overflow: 'hidden', gap: '8px' }}>
      {tags.slice(0, visibleCount).map((tag, index) => (
        <span
          key={index}
          className="badge bg-light text-dark border"
          style={{
            fontSize: '12px',
            padding: '6px 10px',
            borderRadius: '20px',
            whiteSpace: 'nowrap',
            flexShrink: 0
          }}>
          {formatTag(tag)}
        </span>
      ))}

      {hiddenCount > 0 && (
        <span
          className="badge bg-secondary text-white"
          style={{
            fontSize: '12px',
            padding: '6px 10px',
            borderRadius: '20px',
            whiteSpace: 'nowrap',
            flexShrink: 0
          }}>
          +{hiddenCount} more
        </span>
      )}
    </div>
  );
};

FormTags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string),
  formatTag: PropTypes.func
};

FormTags.defaultProps = {
  tags: [],
  formatTag: (tag) => tag
};

export default FormTags;
